import {IBreadcrumbItem} from 'components/breadcrumbs';
import {
    ITableReportPassedDrilldownParams,
    ITableReportLocationDefaults,
    TTableReportRequestGeneralParams,
    ITableReportCustomCrParams,
} from 'components/table-report/table-report-types';
import {IAisRegisterLocationState} from 'pages/ais/documents-register-page/ais-documents-register-types';
import {TLinkMeta, TLinkParameters} from 'shared/types/links';
import {TTableReportRequestParameters} from 'store/slices/table-report-slice/table-report-slice-types';

export enum ELocationStateKey {
    TABLE_REPORT_BREADCRUMBS = 'tableReportBreadcrumbs',
    TABLE_REPORT_PARAMS = 'tableReportParams',
    TABLE_REPORT_LOCATION_DEFAULTS = 'tableReportLocationDefaults',
    TABLE_REPORT_PUSH_UNIQUE_ID = 'tableReportPushUniqueId',
    TABLE_REPORT_REQUEST_GENERAL_PARAMS = 'tableReportGeneralParams',
    TABLE_REPORT_CUSTOM_CR_PARAMS = 'tableReportCustomCrParams',
    DOCUMENT_JOURNAL_PIE_CART = 'docJournalPieChart',
    AIS_REGISTER = 'aisRegister',
    AIS_DOCUMENT_JOURNAL_PIE_CART = 'docJournalPieChart',
    LINK_FILTER_PARAMETERS = 'linkFilterParameters',
    LINK_META = 'linkMeta',
    PASSED_BREADCRUMBS = 'passedBreadcrumbs'
}

export interface IHistoryLocationState {
    // === @COMMON ===
    [ELocationStateKey.PASSED_BREADCRUMBS]?: IBreadcrumbItem[];
    // === TABLE REPORTS ===
    [ELocationStateKey.TABLE_REPORT_BREADCRUMBS]?: IBreadcrumbItem[];
    [ELocationStateKey.TABLE_REPORT_PARAMS]?: ITableReportPassedDrilldownParams;
    [ELocationStateKey.TABLE_REPORT_LOCATION_DEFAULTS]?: ITableReportLocationDefaults;
    [ELocationStateKey.TABLE_REPORT_PUSH_UNIQUE_ID]?: string;
    [ELocationStateKey.TABLE_REPORT_REQUEST_GENERAL_PARAMS]?: TTableReportRequestGeneralParams;
    [ELocationStateKey.TABLE_REPORT_CUSTOM_CR_PARAMS]?: ITableReportCustomCrParams;
    // === AIS ===
    [ELocationStateKey.AIS_REGISTER]?: IAisRegisterLocationState;
    [ELocationStateKey.AIS_DOCUMENT_JOURNAL_PIE_CART]?: TTableReportRequestParameters;
    // === LINK ===
    [ELocationStateKey.LINK_FILTER_PARAMETERS]?: TLinkParameters | null;
    [ELocationStateKey.LINK_META]?: TLinkMeta | null;
}
